<template>
  <div class="manage-requests-page">
    <manage-requests />
  </div>
</template>

<script>
  import ManageRequests from '@/components/Common/ManageRequests/ManageRequests'

  export default {
    components: {
      ManageRequests
    }
  }
</script>

<style lang="scss" scoped>
  .manage-requests-page {
    height: 100%;
    width: 100%;
  }
</style>